/**
 * Mega-menu hover behavior for Craft theme.
 *
 * Craft's <header-menu> uses <details> elements that open on click. This module
 * augments that with pointer hover behavior on desktop:
 *   - 150ms intent delay before opening (prevents accidental triggers)
 *   - 300ms grace period before closing (lets cursor cross gaps)
 *   - Click still works (existing summary toggle behavior is preserved)
 *   - Only activates on devices with fine pointers (skips touch)
 *
 * Mobile / touch / keyboard behavior is unchanged — uses native <details>.
 */

(function () {
  const OPEN_DELAY = 150;
  const CLOSE_DELAY = 300;

  // Only enable on devices with a fine pointer (mouse/trackpad) and adequate width.
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function init() {
    if (!finePointer.matches) return;

    const headerMenus = document.querySelectorAll('header-menu');
    headerMenus.forEach(setupHoverMenu);
  }

  function setupHoverMenu(headerMenu) {
    const details = headerMenu.querySelector('details.mega-menu');
    if (!details) return;
    if (details.dataset.hoverBound === 'true') return;
    details.dataset.hoverBound = 'true';

    let openTimer = null;
    let closeTimer = null;

    const cancelTimers = () => {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    };

    const openMenu = () => {
      cancelTimers();
      openTimer = setTimeout(() => {
        if (!details.open) {
          // Close any siblings so we don't stack multiple open mega-menus.
          document.querySelectorAll('header-menu details.mega-menu[open]').forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
          details.setAttribute('open', '');
        }
      }, OPEN_DELAY);
    };

    const closeMenu = () => {
      cancelTimers();
      closeTimer = setTimeout(() => {
        if (details.open) details.removeAttribute('open');
      }, CLOSE_DELAY);
    };

    headerMenu.addEventListener('mouseenter', openMenu);
    headerMenu.addEventListener('mouseleave', closeMenu);

    // Keyboard focus-in keeps menu open without timer; focus-out closes after delay.
    headerMenu.addEventListener('focusin', cancelTimers);
    headerMenu.addEventListener('focusout', (event) => {
      // Only schedule close if focus is leaving the menu entirely.
      if (!headerMenu.contains(event.relatedTarget)) closeMenu();
    });
  }

  // Initial setup + re-run when sections are dynamically replaced by Shopify editor
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init if the header section is re-rendered (e.g. Shopify theme editor)
  document.addEventListener('shopify:section:load', init);
})();
